/**
 * @generated SignedSource<<6c260eb0676f73d1a265c7088570f112>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingType = "DINING" | "LESSON" | "STANDARD";
export type SlotAvailabilityArgs = {
  bookingType: BookingType;
  facilityId: string;
  instructorIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  lessonTypeId?: string | null | undefined;
};
export type InstructorAvailabilityListQuery$variables = {
  durationMins: number;
  endDateTime: string;
  facilityId: string;
  instructorId: string;
  slotAvailability?: SlotAvailabilityArgs | null | undefined;
  startDateTime: string;
};
export type InstructorAvailabilityListQuery$data = {
  readonly facilityNode: {
    readonly " $fragmentSpreads": FragmentRefs<"AvailabilitySlotsButton_facility">;
  } | null | undefined;
  readonly node: {
    readonly availabilitySlots?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly date: string;
          readonly durationMins: number;
          readonly id: string;
          readonly time: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly session: {
    readonly " $fragmentSpreads": FragmentRefs<"AvailabilitySlots_session">;
  } | null | undefined;
};
export type InstructorAvailabilityListQuery = {
  response: InstructorAvailabilityListQuery$data;
  variables: InstructorAvailabilityListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "durationMins"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDateTime"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "instructorId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slotAvailability"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDateTime"
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "instructorId"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "dateTimeGte",
          "variableName": "startDateTime"
        },
        {
          "kind": "Variable",
          "name": "dateTimeLte",
          "variableName": "endDateTime"
        },
        {
          "kind": "Variable",
          "name": "durationMins",
          "variableName": "durationMins"
        },
        {
          "kind": "Variable",
          "name": "slotAvailability",
          "variableName": "slotAvailability"
        }
      ],
      "concreteType": "AvailabilitySlotConnection",
      "kind": "LinkedField",
      "name": "availabilitySlots",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AvailabilitySlotEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AvailabilitySlot",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "date",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "time",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "durationMins",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StaffProfile",
  "abstractKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "facilityId"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = [
  (v7/*: any*/)
],
v12 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "patronAccess",
    "storageKey": null
  },
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "InstructorAvailabilityListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AvailabilitySlots_session"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "facilityNode",
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AvailabilitySlotsButton_facility"
              }
            ],
            "type": "Facility",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "InstructorAvailabilityListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v11/*: any*/),
                "type": "MemberProfile",
                "abstractKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "Member",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "Customer",
                    "abstractKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "membershipType",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v8/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "facilityNode",
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Club",
                "kind": "LinkedField",
                "name": "club",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "supportsPublic",
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PublicLessonsPermissionSet",
                "kind": "LinkedField",
                "name": "publicLessonsPermissionSet",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PrivateLessonsPermissionSet",
                "kind": "LinkedField",
                "name": "privateLessonsPermissionSet",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": null
              }
            ],
            "type": "Facility",
            "abstractKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "69a384dc01cb430dc92cf29ed1cd15b7",
    "id": null,
    "metadata": {},
    "name": "InstructorAvailabilityListQuery",
    "operationKind": "query",
    "text": "query InstructorAvailabilityListQuery(\n  $instructorId: ID!\n  $startDateTime: Datetime!\n  $endDateTime: Datetime!\n  $durationMins: Int!\n  $slotAvailability: SlotAvailabilityArgs\n  $facilityId: ID!\n) {\n  session {\n    ...AvailabilitySlots_session\n  }\n  node(id: $instructorId) {\n    __typename\n    ... on StaffProfile {\n      availabilitySlots(dateTimeLte: $endDateTime, dateTimeGte: $startDateTime, durationMins: $durationMins, slotAvailability: $slotAvailability) {\n        edges {\n          node {\n            id\n            date\n            time\n            durationMins\n          }\n        }\n      }\n    }\n    id\n  }\n  facilityNode: node(id: $facilityId) {\n    __typename\n    ... on Facility {\n      ...AvailabilitySlotsButton_facility\n    }\n    id\n  }\n}\n\nfragment AvailabilitySlotsButton_facility on Facility {\n  ...useFacilityLessonPatronAccess_facility\n}\n\nfragment AvailabilitySlots_session on Session {\n  currentClientProfile {\n    __typename\n    ... on MemberProfile {\n      id\n    }\n    member {\n      __typename\n      ... on Member {\n        id\n      }\n      ... on Customer {\n        id\n      }\n      club {\n        slug\n        id\n      }\n      membershipType {\n        __typename\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ...useUserBelongsToCurrentClub_session\n}\n\nfragment useFacilityLessonPatronAccess_facility on Facility {\n  club {\n    supportsPublic\n    id\n  }\n  publicLessonsPermissionSet {\n    patronAccess\n    id\n  }\n  privateLessonsPermissionSet {\n    patronAccess\n    id\n  }\n}\n\nfragment useUserBelongsToCurrentClub_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        id\n      }\n      ... on Member {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "851ce6677499bffefbcf37c29d82904d";

export default node;
